module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/main-visual_miyakojima-8df61797e03d6b5683eb79be3c910b13.jpg";